"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _default = {
  "tagliolo-monferrato": {
    "fed8ae8a": [{
      "hkey": "aa67625d",
      "slug": "san-pietro-caviggi",
      "name": "San Pietro-Caviggi",
      "primary": true,
      "skipSearch": false
    }],
    "caviggi": [{
      "hkey": "aa67625d",
      "slug": "san-pietro-caviggi",
      "name": "San Pietro-Caviggi",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 10,
      "slugLevelParent": "tagliolo-monferrato"
    }],
    "e8d96f18": [{
      "hkey": "d9344222",
      "slug": "cherli",
      "name": "Cherli",
      "primary": true,
      "skipSearch": false
    }],
    "cherli-cadilana": [{
      "hkey": "d9344222",
      "slug": "cherli",
      "name": "Cherli",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 10,
      "slugLevelParent": null
    }],
    "34d3932c": [{
      "hkey": "78b5375f",
      "slug": "tagliolo-monferrato",
      "name": "Tagliolo Monferrato",
      "primary": true,
      "skipSearch": false
    }],
    "masseria": [{
      "hkey": "78b5375f",
      "slug": "tagliolo-monferrato",
      "name": "Tagliolo Monferrato",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }],
    "34fd51c9": [{
      "hkey": "78b5375f",
      "slug": "tagliolo-monferrato",
      "name": "Tagliolo Monferrato",
      "primary": true,
      "skipSearch": false
    }],
    "pianomoglia": [{
      "hkey": "78b5375f",
      "slug": "tagliolo-monferrato",
      "name": "Tagliolo Monferrato",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }],
    "65942de3": [{
      "hkey": "aa67625d",
      "slug": "san-pietro-caviggi",
      "name": "San Pietro-Caviggi",
      "primary": true,
      "skipSearch": false
    }],
    "san-pietro": [{
      "hkey": "aa67625d",
      "slug": "san-pietro-caviggi",
      "name": "San Pietro-Caviggi",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 10,
      "slugLevelParent": "tagliolo-monferrato"
    }]
  }
};
exports["default"] = _default;